import React from 'react'
import YogaHero from '../components/scienceofyoga/YogaHero'
import YogaContent from '../components/scienceofyoga/YogaContent'

const ScienceOfYoga = () => {
  return (
   <>
   <YogaHero/>
   <YogaContent/>
   </>
  )
}

export default ScienceOfYoga